module.exports = __webpack_public_path__ + "img/na.e5f28e44.svg";